export const initialState = {
  exibir: false,
  etapaAtual: 0,
  error: '',
  isLoading: false,
};
